var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-bar"},[_c('h1',[_vm._v(_vm._s(_vm.title)+" "),(_vm.count)?_c('span',[_vm._v("("+_vm._s(_vm.count)+")")]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }